<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div class="row no-gutters mb-input-margin-bottom">
    <div class="col-12 field-wrapper text-sm-left"
         mbFloatingLabel
         data-cy="mb-checkout-address-zipcode">
      <label for="postalCode" class="mandatory-input-asterisk mb-input-field-cursor mb-custom-label">{{ zipCodeLabelKey | cxTranslate }}</label>
      <input class="w-100 mb-form-input"
             id="postalCode"
             name="postalCode"
             data-cy="mb-checkout-address-zipcode-input"
             type="text"
             formControlName="postalCode"
             required/>
      <mb-form-errors [control]="formGroup?.get(constants.POSTAL_CODE_CODE)"
                      [prefix]="'formValidationErrors'">
      </mb-form-errors>
    </div>
  </div>

</div>
